import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";

import {ModuleAPI} from "@/api/module";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";

import {SUCCESSFUL_OPERATION, ERROR_OPERATION} from "@/utils/constants";
import {checkRequiredFields, getTextField} from "@/utils/functions";

const HandleSettingsModulePage = (props) => {
	const {edit, handleNotification} = props;

	const navigate = useNavigate();
	const {id} = useParams();

	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState([]);
	const [fields, setFields] = useState({});

	const getModule = async () => {
		setLoading(true);
		try {
			const response = await ModuleAPI.getById(id);
			setFields(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (edit) {
			getModule();
		}
	}, [edit]);

	const getRequiredFields = () => ["name"];

	const saveModule = async () => {
		const requiredErrors = checkRequiredFields(getRequiredFields(), fields);
		setErrors(requiredErrors);

		if (!requiredErrors.length) {
			setLoading(true);
			const body = Object.assign({}, fields);

			try {
				const response = edit
					? await ModuleAPI.update(id, body)
					: await ModuleAPI.create(body);
				setTimeout(() => {
					navigate(
						edit
							? `/settings/modules/${response?.id || id}`
							: "/settings/modules",
					);
					handleNotification(SUCCESSFUL_OPERATION, "success");
				}, 1000);
			} catch (error) {
				handleNotification(ERROR_OPERATION, "error");
				setLoading(false);
			}
		}
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		saveModule();
	};

	const goBack = () => {
		if (edit) {
			navigate("/settings/modules/" + id);
		} else {
			navigate("/settings/modules");
		}
	};

	const mainActions = [
		{
			icon: <ArrowBackIcon />,
			title: "Indietro",
			onClick: goBack,
			color: "info",
		},
		{
			icon: <SaveIcon />,
			title: "Salva",
			onClick: handleSubmit,
			disabled: !!checkRequiredFields(getRequiredFields(), fields).length,
		},
	];

	const breadcrumbsElements = [
		{label: "Moduli tattici", path: "/settings/modules"},
	];
	if (edit) {
		breadcrumbsElements.push(
			{label: "/"},
			{
				label: fields ? fields.name : "",
				path: "/settings/modules/" + id,
			},
		);
	}

	const defaultTextField = {
		values: fields,
		setValues: setFields,
		errors,
		setErrors,
	};

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				elements={breadcrumbsElements}
				current={edit ? "Modifica" : "Nuovo modulo"}
				actions={<MainActions actions={mainActions} />}
			/>
			<div className="row no-margin">
				<div className="col-sm-12 padding-small">
					<VLFCard
						title="Informazioni principali"
						content={
							<div className="row">
								<div className="col-sm-12">
									{getTextField({
										...defaultTextField,
										fieldKey: "name",
										label: "Nome",
										required: true,
									})}
								</div>
								<div className="col-sm-6 col-md-2">
									{getTextField({
										...defaultTextField,
										fieldKey: "defenders",
										label: "Difensori",
										type: "number",
									})}
								</div>
								<div className="col-sm-6 col-md-2">
									{getTextField({
										...defaultTextField,
										fieldKey: "defensiveMidfielders",
										label: "Mediani",
										type: "number",
									})}
								</div>
								<div className="col-sm-6 col-md-2">
									{getTextField({
										...defaultTextField,
										fieldKey: "centralMidfielders",
										label: "Centrocampisti",
										type: "number",
									})}
								</div>
								<div className="col-sm-6 col-md-2">
									{getTextField({
										...defaultTextField,
										fieldKey: "attackingMidfielders",
										label: "Trequartisti",
										type: "number",
									})}
								</div>
								<div className="col-sm-6 col-md-2">
									{getTextField({
										...defaultTextField,
										fieldKey: "attackers",
										label: "Attaccanti",
										type: "number",
									})}
								</div>
							</div>
						}
						openable={false}
					/>
				</div>
			</div>
		</Page>
	);
};

export default HandleSettingsModulePage;
